import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { AccountApiService } from './account.service';
import {
  loadAccountList,
  loadAccountListSuccess,
  loadAccountListFailure,
} from './account.actions';

@Injectable()
export class AccountEffects {
  private actions$ = inject(Actions);
  private accountService = inject(AccountApiService);

  loadAccountList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAccountList),
      mergeMap(() =>
        this.accountService.getAccountList().pipe(
          map((response: any) => {
            if (response.status === 'Failed') {
              return loadAccountListFailure({ error: response.message });
            }
            return loadAccountListSuccess({ data: response.data });
          }),
          catchError((error) => of(loadAccountListFailure({ error })))
        )
      )
    )
  );
}
